<template>
  <a-modal
      :visible="visible"
      :closable="false"
      @cancel="visible = false"
      :footer="null"
      :width="340"
  >
    <div class="header">
      <div>将商品添加至达人橱窗</div>
      <router-link to="/setting/mine-auth">
        <div class="button-add" >管理达人号</div>
      </router-link>
    </div>
    <a-radio-group  v-model="formData.tik_tok_id" style="width: 100%;">
    <a-list v-if="tiktok" :data-source="tiktok.list">
      <a-list-item slot="renderItem" slot-scope="item" style="width: 100%;">
        <a-list-item-meta :description="item.time_str" style="width: 100%;">
          <a slot="title" :href="item.href">{{item.nickname}}</a>
          <a-avatar
              slot="avatar"
              :src="item.head_img"
          />
        </a-list-item-meta>
        <a-radio  :value="item.id" @change="handleChange(item)"></a-radio>
      </a-list-item>
      <div v-if="loading && !busy" class="demo-loading-container">
        <a-spin />
      </div>
    </a-list>
    </a-radio-group>
    <div class="footer">
      <a-button class="button confirm" :disabled="!formData.tik_tok_id"  @click="handleConfirm">确认</a-button>
      <a-button class="button" @click="visible = false">取消</a-button>
    </div>

  </a-modal>
</template>

<script>
import {fetchAccount} from '@/api/douyin'
import { addWindow } from '@/api/goods-list'

export default {
  name: "index",
  data() {
    return {
      visible: false,
      data: [],
      loading: false,
      busy: false,
      tiktok: undefined,
      formData: {},
      goods: {},
    }
  },
  beforeMount() {
  },
  methods: {
    show(goods) {
      console.log(goods)
      this.goods = goods
      const {good_id} = goods
      this.visible = true
      this.formData = {
        gid: good_id
      }
      this.fetchData()
    },
    fetchData() {
      fetchAccount(this.goods.provider).then(res => {
        this.tiktok = res
        if (res.list && res.list.length > 0) {
          this.formData.tik_tok_id = res.list[0].id
        }
      })
    },
    handleConfirm() {
      this.formData.id = this.formData.tik_tok_id
      addWindow(this.formData, this.goods.provider).then(res => {
        console.log(res)
        this.$message.success('商品加入橱窗成功');
        this.visible = false
      })
    },
    handleChange(e) {
      console.log(e)
      this.formData.tik_tok_id = e.id
      this.$forceUpdate()
    }
  }
}
</script>

<style scoped lang="scss">
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;

  font-weight: 500;
  color: #000000;
  line-height: 22px;

  .button-add {
    height: 32px;
    background: #E9F2FF;
    border-radius: 6px;
    border: 1px solid #1890FF;
    padding-left: 10px;
    padding-right: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 14px;
    color: #1890FF;
    line-height: 20px;
  }
}
.footer {
  display: flex;
  align-items: center;
  justify-content: center;


  .button {
    width: 106px;
    height: 40px;
    border-radius: 6px;
    font-size: 14px;
    font-weight: 500;
    text-align: center;
    line-height: 40px;
    margin: 5px;
  }

  .confirm {
    color: #FFFFFF;
    background: #8D12F8;
  }
}
</style>
